import { useEffect, useMemo, useState, useRef } from "react";
import { AttendanceStatusCell } from "./AttendanceStatusCell";
import { FaSave, FaEdit } from "react-icons/fa";
import { TbCancel } from "react-icons/tb";
import EditAttendance from "./EditAttendance";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { useSelector } from "react-redux";
import { DoorStepEmployeeAttendanceStatusCell } from "../DoorStepEmployee/DoorStepAttendance/DoorStepEmployeAttendanceStatusCell";
const legendItems = [
  { title: "P", label: "Present", className: "btn-success" },
  { title: "A", label: "Absent", className: "btn-danger" },
  {
    title: "H",
    status: "half day",
    label: "Half Day",
    className: "btn-warning",
  },
];
const doorStepLegends = [
  { title: "P", label: "Present", className: "btn-success" },
  { title: "A", label: "Absent", className: "btn-danger" },
  {
    title: "H",
    label: "Holi Day",
    className: "btn-warning",
  },
  { title: "EL", className: "btn-info", label: "Earned leave" },
  { title: "PL", className: "btn-success", label: "Paid leave" },
  { title: "UL", className: "btn-warning", label: "Unpaid leave" },
];
export function AttendanceTable({
  createLoading,
  loading,
  param,
  total,
  setParam,
  employees,
  attendanceData,
  setAttendaceData,
  onStatusChange,
  selectedMonth,
  onSave,
  confirmEditMode,
  setConfirmEditMode,
  editColumn,
  setEditColumn,
  isMarked = false,
  isDoorStep = false,
}) {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || "user"
  );
  const [editMode, setEditMode] = useState(false);
  const [cancelEditMode, setCancelEditMode] = useState(false);
  const [copyAttendanceData, setCopyAttendanceData] = useState(null);
  const handleToggleEdit = () => {
    setEditMode(!editMode);
  };

  const handelEditConfirm = () => {
    setConfirmEditMode(true);
    setCopyAttendanceData(JSON.parse(JSON.stringify(attendanceData)));
  };

  const handleToggleEditCancel = () => {
    setCancelEditMode(!cancelEditMode);
  };

  const handleCancelConfirm = () => {
    setConfirmEditMode(false);
    setAttendaceData(copyAttendanceData);
    setCopyAttendanceData(null);
    setEditColumn([]);
  };
  const daysInMonth = useMemo(() => {
    const year = parseInt(selectedMonth?.split(" ")[1]);
    const monthName = selectedMonth?.split(" ")[0];
    const monthIndex = new Date(Date.parse(monthName + " 1, 2012")).getMonth();
    const daysCount = new Date(year, monthIndex + 1, 0).getDate();
    return Array.from({ length: daysCount }, (_, i) => i + 1);
  }, [selectedMonth]);
  const getDayOfWeek = (date) => {
    const year = parseInt(selectedMonth?.split(" ")[1]);
    const monthName = selectedMonth?.split(" ")[0];
    const monthIndex = new Date(Date.parse(monthName + " 1, 2012")).getMonth();
    const dayOfWeek = new Date(year, monthIndex, date).getDay();
    return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dayOfWeek];
  };
  const checkPastDate = (date) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const [monthName, yearStr] = selectedMonth.trim().split(" ");
    const year = parseInt(yearStr, 10);
    const monthIndex = monthNames.indexOf(monthName);

    const today = new Date();
    const todayOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const selectedOnly = new Date(year, monthIndex, Number(date));

    return selectedOnly < todayOnly;
  };
  const checkCurrentDate = (date) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const [monthName, yearStr] = selectedMonth.trim().split(" ");
    const year = parseInt(yearStr, 10);
    const monthIndex = monthNames.indexOf(monthName);

    const today = new Date();
    const todayOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const selectedOnly = new Date(year, monthIndex, Number(date));

    return selectedOnly.getTime() === todayOnly.getTime();
  };
  const checkFutureDate = (date) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const [monthName, yearStr] = selectedMonth.trim().split(" ");
    const year = parseInt(yearStr, 10);
    const monthIndex = monthNames.indexOf(monthName);

    const today = new Date();
    const todayOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    const selectedOnly = new Date(year, monthIndex, Number(date));

    // ✅ true if the date is in the future
    return selectedOnly > todayOnly;
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const tableRef = useRef(null);
  //scroll to today
  useEffect(() => {
    setTimeout(() => {
      if (tableRef.current) {
        const todayCol = tableRef.current.querySelector(
          "th[data-today='true']"
        );
        if (todayCol) {
          const container = tableRef.current;
          const colLeft = todayCol.offsetLeft;
          const targetScroll = Math.max(colLeft - 240, 0);
          container.scrollTo({
            left: targetScroll,
            behavior: "smooth",
          });
        }
      }
    }, 300);
  }, []);
  const handleCheck = (date, isChecked) => {
    setAttendaceData((prev) => {
      const updated = { ...prev };
      employees.forEach((emp) => {
        if (!updated[emp.id]) {
          updated[emp.id] = {};
        }
        if (isChecked) {
          updated[emp.id][date] = { status: "PRESENT", isEditable: true };
        } else {
          updated[emp.id][date] = { status: "ABSENT", isEditable: true };
        }
      });
      return updated;
    });

    setEditColumn((prev) =>
      prev.includes(date) ? prev.filter((d) => d !== date) : [...prev, date]
    );
  };

  return (
    <div className="card shadow-sm">
      <div className="p-2">
        {userRole !== "admin" && (
          <div
            className={`alert ${
              isMarked ? "alert-warning" : "alert-danger"
            } rounded-2 mb-2 d-flex align-items-start`}
            style={{ fontSize: "0.85rem", padding: "0.5rem" }}
          >
            <span>
              <IoMdInformationCircleOutline className="me-2" size={22} />
            </span>
            <span>
              {isMarked
                ? "Attendance for this date has already been submitted successfully. Please note that the system does not allow duplicate attendance entries."
                : "Attendance for this date has not been recorded yet. Kindly complete your attendance marking to keep your records up to date."}
            </span>
          </div>
        )}

        <div className="d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex flex-wrap gap-3">
            {[...(isDoorStep ? doorStepLegends : [...legendItems])].map(
              (item, index) => (
                <div key={index} className="d-flex align-items-center">
                  <button
                    className={`btn btn-sm ${item.className} me-1`}
                    style={{
                      width: "20px",
                      height: "22px",
                      fontSize: "10px",
                      fontWeight: "bold",
                      cursor: "default",
                    }}
                  >
                    {item.title}
                  </button>
                  <span
                    className="text-dark fw-medium"
                    style={{ fontSize: "0.85rem" }}
                  >
                    {item.label}
                  </span>
                </div>
              )
            )}
          </div>
          {userRole !== "admin" && (
            <div className="d-flex justify-content-between gap-2 flex-wrap">
              {!confirmEditMode ? (
                <button
                  onClick={handleToggleEdit}
                  className="btn stylish-transparent-btn position-relative"
                >
                  <FaEdit size={16} className="me-1" />
                  Edit All
                </button>
              ) : (
                <button
                  onClick={handleToggleEditCancel}
                  className="btn stylish-transparent-btn position-relative text-danger"
                >
                  <TbCancel size={16} className="me-1 text-danger" />
                  Cancel
                </button>
              )}
              <button
                onClick={onSave}
                className={`btn stylish-transparent-btn position-relative`}
                disabled={createLoading}
              >
                {createLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <FaSave size={18} className="me-2" />
                )}
                Submit
                {/* {changesCount?.length > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-circle shadow bg-primary"
                    style={{ fontSize: "0.6rem", padding: "0.3rem 0.4rem" }}
                  >
                    {changesCount?.length}
                  </span>
                )} */}
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="card-body p-0">
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <div className="table-responsive" ref={tableRef}>
            <table className="table table-bordered mb-0">
              <thead>
                <tr>
                  <th
                    className="bg-lighter border-end align-middle"
                    // style={
                    //   !isMobile
                    //     ? {
                    //         minWidth: "180px",
                    //         position: "sticky",
                    //         left: 0,
                    //         zIndex: 10,
                    //       }
                    //     : { minWidth: "180px" }
                    // }
                    style={{
                      minWidth: "180px",
                      position: "sticky",
                      left: 0,
                      zIndex: 15,
                    }}
                  >
                    Employee Name
                  </th>
                  {daysInMonth.map((date) => {
                    const dayOfWeek = getDayOfWeek(date);
                    const isSunday = dayOfWeek === "Sun";
                    const isPastDate = checkPastDate(date);
                    const isToday = checkCurrentDate(date);

                    return (
                      <th
                        key={date}
                        className="text-center"
                        data-today={isToday ? "true" : "false"}
                        style={{
                          minWidth: "50px",
                          backgroundColor: isSunday
                            ? "#ef2b2b"
                            : isPastDate
                            ? "#24c05d"
                            : isToday
                            ? "#f7c716"
                            : undefined,
                        }}
                      >
                        <div>
                          <div
                            className={`fw-medium ${
                              isSunday || isPastDate ? "text-white" : ""
                            }`}
                            style={{ fontSize: "0.85rem" }}
                          >
                            {date}
                          </div>
                          <div className="d-flex gap-1 align-items-center">
                            <small
                              style={{ fontSize: "0.72rem" }}
                              className={`${
                                isSunday || isPastDate
                                  ? "text-white"
                                  : "text-darker"
                              }`}
                            >
                              {dayOfWeek}
                            </small>
                            {isPastDate && confirmEditMode && (
                              <span className="form-check d-flex justify-content-center m-0">
                                <input
                                  type="checkbox"
                                  className={`form-check-input custom-checkbox ${
                                    isSunday ? "checkbox-red" : "checkbox-green"
                                  }`}
                                  checked={editColumn.includes(date)}
                                  onChange={(e) =>
                                    handleCheck(date, e.target.checked)
                                  }
                                />
                              </span>
                            )}
                          </div>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {employees && employees.length > 0 ? (
                  employees.map((employee, index) => (
                    <tr key={employee?.id || index}>
                      <td
                        className="fw-medium bg-lighter border-end fs-6 align-middle"
                        // style={
                        //   !isMobile
                        //     ? { position: "sticky", left: 0, zIndex: 5 }
                        //     : {}
                        // }
                        style={{ position: "sticky", left: 0, zIndex: 5 }}
                      >
                        <span>
                          {employee?.name}{" "}
                          {(() => {
                            const records =
                              attendanceData?.[employee?.id] || {};
                            const presentCount = Object.values(records).filter(
                              (r) => r?.status?.toLowerCase() === "present"
                            ).length;

                            return (
                              <span
                                className="badge text-bg-success-soft rounded-1 ms-1 border border-success"
                                style={{
                                  fontSize: "0.5rem",
                                  padding: "0.2rem 0.28rem",
                                }}
                              >
                                {presentCount || 0}
                              </span>
                            );
                          })()}
                        </span>
                      </td>

                      {daysInMonth.map((date) => {
                        const isPastDate = checkPastDate(date);
                        const isFutureDay = checkFutureDate(date);

                        return (
                          <td
                            key={date}
                            className="text-center align-middle"
                            style={{ padding: "8px" }}
                          >
                            {isDoorStep ? (
                              <DoorStepEmployeeAttendanceStatusCell
                                employeeId={employee?.id}
                                date={date}
                                status={
                                  attendanceData?.[employee?.id]?.[date]
                                    ?.status || ""
                                }
                                onStatusChange={onStatusChange}
                                isPastDate={isPastDate}
                                isFutureDay={isFutureDay}
                                isEditable={confirmEditMode}
                              />
                            ) : (
                              <AttendanceStatusCell
                                employeeId={employee?.id}
                                date={date}
                                status={
                                  attendanceData?.[employee?.id]?.[date]
                                    ?.status || ""
                                }
                                onStatusChange={onStatusChange}
                                isPastDate={isPastDate}
                                isFutureDay={isFutureDay}
                                isEditable={confirmEditMode}
                              />
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={daysInMonth.length + 1}
                      className="text-center py-4 text-muted"
                    >
                      No employees found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {!loading && employees?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <EditAttendance
        open={editMode}
        onClose={handleToggleEdit}
        onConfirm={handelEditConfirm}
      />

      <EditAttendance
        open={cancelEditMode}
        onClose={handleToggleEditCancel}
        onConfirm={handleCancelConfirm}
        isCancel={true}
      />
    </div>
  );
}
